import { Text, View } from 'react-native';

import {
  DayOfWeek,
  daysOfWeek,
  useContent,
  weekdayNamesContent,
} from '@altify/utils';
import { Heading } from '../../Core/Heading/Heading';
import { cn } from '../../lib/utils';
import { content } from './Calendar.content';
import { CircularButton } from './components/CircularButton';

export const WeekCalendar = ({
  weekDaySelection = 'Monday',
  className,
  circularButtonClassName,
  onChange,
}: {
  className?: string;
  circularButtonClassName?: string;
  weekDaySelection: DayOfWeek | undefined;
  onChange?: (value: DayOfWeek) => void;
}) => {
  const localizedContent = useContent(content, weekdayNamesContent);
  return (
    <View
      className={cn(
        'bg-neutral-600 rounded-[10px] p-3 items-center border border-neutral-500',
        className,
      )}>
      <Text className="mt-1 text-center">
        <Heading level={4}> {localizedContent.buyWeekDate.buyOn}</Heading>
        <Heading level={4} className="text-primary">
          {` ${localizedContent.weekdays[weekDaySelection].long} `}
        </Heading>
        <Heading level={4} className="text-center">
          {localizedContent.buyWeekDate.eachWeek}
        </Heading>
      </Text>
      <View className="flex-row justify-evenly w-full mt-4">
        {daysOfWeek.map(day => (
          <CircularButton
            className={circularButtonClassName}
            key={day}
            onPress={() => {
              onChange?.(day);
            }}
            isSelected={weekDaySelection === day}
            text={localizedContent.weekdays[day].short}
          />
        ))}
      </View>
    </View>
  );
};
